import {resources} from "../../../../../../../core/models/resource/resources";
import {EntityFileType} from "../../../../../../../core/types/file.types";

export const bannerFilesResourceType = resources['banner-files'];
export const socialMediaFilesResourceType = resources['social-media-files'];

export const bannersSocialFilesPath: Record<string, string> = {
  banners: bannerFilesResourceType.path,
  socialMedia: socialMediaFilesResourceType.path
}

export const bannersSocialEntityFileTypes: Record<string, EntityFileType> = {
  banners: 'BANNERS',
  socialMedia: 'SOCIAL_MEDIA'
}

export const bannersSocialGetFilesParamKeys: Record<string, string> = {
  banners: 'bannerId',
  socialMedia: 'socialMediaId',
}
